import * as RT from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";
import { cn } from "./cn";

export function TooltipProvider({ children }: { children: ReactNode }) {
  return <RT.Provider delayDuration={250}>{children}</RT.Provider>;
}

export function Tooltip({
  label,
  children,
  side = "right",
  className,
}: {
  label: string;
  children: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  className?: string;
}) {
  return (
    <RT.Root>
      <RT.Trigger asChild>{children}</RT.Trigger>
      <RT.Portal>
        <RT.Content
          side={side}
          sideOffset={6}
          className={cn(
            "z-50 rounded-md border border-[var(--border)] bg-[var(--surface)] px-2 py-1 text-xs text-[var(--fg)] shadow-[var(--shadow-1)]",
            "data-[state=delayed-open]:animate-in data-[state=delayed-open]:fade-in-0",
            className,
          )}
        >
          {label}
          <RT.Arrow className="fill-[var(--surface)] stroke-[var(--border)]" />
        </RT.Content>
      </RT.Portal>
    </RT.Root>
  );
}
